
export const TOP_N = 10;

export const CONSENSUS_PENALTY = 11;

export const TOOLTIP_SX = {
  bgcolor: "#1e2340",
  fontSize: "0.73rem",
  borderRadius: "10px",
  padding: "8px 12px",
  boxShadow: "0 6px 20px rgba(0,0,0,0.28)",
  "& .MuiTooltip-arrow": { color: "#1e2340" },
};

export function withDisplayRanks(entries) {
  const top = (entries || []).slice(0, TOP_N);
  let lastAvgRank = null;
  let lastDisplayRank = null;

  return top.map((entry, index) => {
    const displayRank =
      lastAvgRank !== null && entry.avgRank === lastAvgRank ? lastDisplayRank : index + 1;
    lastAvgRank = entry.avgRank;
    lastDisplayRank = displayRank;
    return { ...entry, displayRank };
  });
}

export function RankBreakdownTooltip({ name, ranks, rankLabels }) {
  const items = ranks || [];
  const isLabeledByLlm = items.length > 0 && typeof items[0] === "object" && items[0] !== null;

  return (
    <div style={{ minWidth: 150 }}>
      {name && (
        <div style={{ fontWeight: 700, fontSize: "0.75rem", color: "#fff", marginBottom: 6 }}>
          {name}
        </div>
      )}
      {items.map((item, i) => {
        const [label, rank] = isLabeledByLlm
          ? Object.entries(item)[0] || []
          : [rankLabels?.[i] || `Set ${i + 1}`, item];
        if (label === undefined) return null;

        return (
          <div key={i} style={{ marginBottom: i < items.length - 1 ? 4 : 0, display: "flex", alignItems: "center", gap: 5 }}>
            <span style={{ fontWeight: 700, fontSize: "0.73rem", color: "#a8c4f0" }}>{label}</span>
            <span style={{ fontSize: "0.71rem", opacity: 0.85 }}>
              {rank >= CONSENSUS_PENALTY ? "N/A" : `#${rank}`}
            </span>
          </div>
        );
      })}
    </div>
  );
}
